/**
 * gets label or default fallback
 * @param  {String} options.label
 * @return {String}
 */
export const getLabel = ({ label }) => {
  if (label) return label;

  return 'Select Date';
};
